import { Link } from "react-router-dom";
import type { CatalogOutcome } from "@/hooks/use-catalog";
import { formatTokens } from "@/lib/utils";

export function OutcomeCard({ outcome }: { outcome: CatalogOutcome }) {
  const priceLabel =
    outcome.price_kind === "variable" && outcome.max_price_tokens
      ? `${formatTokens(outcome.price_tokens)}–${formatTokens(outcome.max_price_tokens)}`
      : formatTokens(outcome.price_tokens);

  return (
    <Link
      to={`/outcomes/${outcome.partner_slug}/${outcome.slug}`}
      className="group flex flex-col rounded-xl border border-neutral-200 bg-white p-5 transition hover:border-emerald-300 hover:shadow-sm dark:border-neutral-800 dark:bg-neutral-950 dark:hover:border-emerald-700"
    >
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <h3 className="truncate text-base font-semibold group-hover:text-emerald-600 dark:group-hover:text-emerald-400">
            {outcome.name}
          </h3>
          <p className="mt-0.5 truncate text-xs text-neutral-500">
            {outcome.partner_name}
          </p>
        </div>
        {outcome.rating_count > 0 ? (
          <div className="shrink-0 text-xs text-neutral-500">
            <span className="text-amber-500">★</span>{" "}
            {outcome.rating_avg.toFixed(1)} ({outcome.rating_count})
          </div>
        ) : null}
      </div>

      {outcome.description ? (
        <p className="mt-3 line-clamp-2 text-sm text-neutral-600 dark:text-neutral-400">
          {outcome.description}
        </p>
      ) : null}

      <div className="mt-auto flex items-center justify-between pt-4 text-sm">
        <span className="font-medium">
          {priceLabel} <span className="text-neutral-400">tokens</span>
        </span>
        <span className="text-xs text-neutral-400">
          {outcome.delivery_mode === "sync" ? "Fast" : "Async"}
        </span>
      </div>
    </Link>
  );
}
